import React from 'react';
import Box from '@stitch-fix/mode-react/Box';
import Grid from '@stitch-fix/mode-react/Grid';
import { Chiclet, useVisionStatus } from '@stitch-fix/vision-shared';
import { hasChicletImage, isOutOfStock, sortShopProductVariants } from '../../../../utils/sortShopProductVariants';
import { CurrentLook, ShopProductVariant } from '../graphql/types';
const GalleryProductCards = ({
  look
}: {
  look: CurrentLook;
}) => {
  const {
    isPrimaryAccount
  } = useVisionStatus();
  const outfitId = look.shopProductVariants.map(item => item.sku).join('-');
  const sortedShopProductVariants = React.useMemo(() => sortShopProductVariants(look.shopProductVariants.filter(hasChicletImage)), [look.shopProductVariants]);
  return <Box data-testid="gallery-product-cards">
      <Grid columns={{
      sm: 4
    }} spacing="tight">
        {sortedShopProductVariants.map((variant: ShopProductVariant) => <Chiclet key={variant.id} href={look.shopProductVariants.length ? `${variant.url}&outfit_id=${outfitId}` : variant.url} image={variant.image ?? {}} isOutOfStock={isOutOfStock(variant)} ariaLabel={variant.shopProduct.name} sku={variant.sku} isPurchased={variant.purchased} rounded isPrimaryAccount={isPrimaryAccount} />)}
      </Grid>
    </Box>;
};
export default GalleryProductCards;